import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface Contact {
  id?: number;
  name: string;
  phoneNumber?: string;
  email?: string;
  companyName?: string;
  ico?: string;
  address?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getMyContacts = async (token: string): Promise<Contact[]> => {
  const res = await axios.get(`${API_BASE}/contacts`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const getContactById = async (id: number, token: string): Promise<Contact> => {
  const res = await axios.get(`${API_BASE}/contacts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const createContact = async (contact: Contact, token: string): Promise<Contact> => {
  const res = await axios.post(`${API_BASE}/contacts`, contact, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const updateContact = async (id: number, contact: Contact, token: string): Promise<Contact> => {
  const res = await axios.put(`${API_BASE}/contacts/${id}`, contact, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const deleteContact = async (id: number, token: string): Promise<void> => {
  await axios.delete(`${API_BASE}/contacts/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
};
